/** Ortak ve hata metinleri (en); panel, vitrin ve API birlikte kullanır (F7-17'de ayrıldı). */
import { faz8ErrorsEn } from './faz8.en';
import { aiErrorsEn } from './ai.errors.en';

export const commonEn = {
  appName: 'Zootopia Panel',
  save: 'Save',
  cancel: 'Cancel',
  done: 'Done',
  delete: 'Delete',
  edit: 'Edit',
  create: 'Create',
  add: 'Add',
  close: 'Close',
  back: 'Back',
  previous: 'Previous',
  next: 'Next',
  confirm: 'Confirm',
  loading: 'Loading…',
  saved: 'Saved',
  yes: 'Yes',
  no: 'No',
  none: 'None',
  all: 'All',
  status: 'Status',
  actions: 'Actions',
  name: 'Name',
  email: 'Email',
  password: 'Password',
  search: 'Search',
  copy: 'Copy',
  copied: 'Copied',
  optional: 'optional',
  required: 'required',
  noData: 'No data yet',
  unknown: 'Unknown',
  retry: 'Try again',
  help: 'Help',
  whatIsThisPage: 'What is this page for?',
  lockedPhase: 'Available in phase {{phase}}',
  createdAt: 'Created',
  updatedAt: 'Updated',
  lastUsed: 'Last used',
  never: 'Never',
  signOut: 'Sign out',
  modeBeginner: 'Beginner mode',
  modeAdvanced: 'Advanced mode',
  language: 'Language',
  theme: 'Theme',
  themeLight: 'Light',
  themeDark: 'Dark',
  themeSystem: 'System',
  reveal: 'Show',
  days: '{{count}} days',
  more: 'Load more',
  remove: 'Remove',
  deleted: 'Deleted',
};

// Faz 8 hata metinleri ayrı dosyada; tek satırla eklenir (ADR-801).
export const errorsEn = {
  ...faz8ErrorsEn,
  ...aiErrorsEn,
  section_type_unavailable: 'This section type is not available yet.',
  section_target_missing: 'The selected category or product was not found; choose another.',
  section_image_required: 'Upload an image for this section.',
  banner_image_required: 'Upload a desktop image for this placement.',
  question_too_short: 'Your question must be at least 10 characters.',
  question_answer_required: 'Write an answer before publishing.',
  favorites_full: 'Your favorites list is full (max 200 products); remove some to add more.',
  post_published_delete: 'A published post cannot be deleted; you can unpublish it.',
  post_body_required: 'Write the post text before publishing.',
  banner_text_required: 'Write a text for this placement.',
  banner_image_not_allowed: 'The announcement bar does not use images.',
  banner_link_required: 'Enter a link address for the button text.',
  end_before_start: 'The end date must be after the start date.',
  banner_active_delete: 'An active banner cannot be deleted; stop it first.',
  banner_order_mismatch: 'The order list does not match the banners in this placement; reload and try again.',
  content_file_missing: 'An image in the content was not found; upload it again.',
  unpublish_before_publish: 'The unpublish date must be after the publish date.',
  page_home_exists: 'This store already has a home page in this language.',
  locale_not_in_store:
    "This language is not among the store's markets. Add a market in this language on the Stores screen first.",
  locale_unsupported: 'This language is not supported (choose Turkish, English, German or Arabic).',
  translation_same_locale: "A translation must be in a language other than the content's own language.",
  translation_exists:
    'This content already has a translation in this language; open it from the language filter.',
  content_locale_mismatch:
    'The selected content is in another language; choose the page, post or category in this language.',
  page_published_delete: 'A published page cannot be deleted (its history is kept); unpublish it instead.',
  content_review_required:
    'Health content or a health claim is present: publishing requires Veterinary Expert approval.',
  content_review_rejected: 'The content was rejected in expert review; fix it and submit again.',
  content_review_not_required: 'This content does not need expert approval.',
  invalid_item_id: 'Invalid menu item id; reload the page and try again.',
  duplicate_item_id: 'The same menu item was added twice; reload the page and try again.',
  menu_too_deep: 'The menu cannot be nested deeper here (header 3, footer 2 levels).',
  menu_item_link_required: 'A menu item without sub-items needs a link.',
  menu_too_many_items: 'A menu can have at most 150 items.',
  menu_target_missing: 'The linked category or product was not found; choose another target.',
  theme_no_draft: 'There is no theme draft to publish. Save the draft first.',
  theme_draft_invalid: 'The theme draft could not be read; save it again in the editor.',
  theme_contrast_failed:
    'The theme cannot be published: {{count}} colour pairs are not readable enough. Fix the warnings in the editor.',
  theme_no_changes: 'This theme is already live; nothing changed.',
  theme_dark_palette_required: 'Dark colours are required to follow the device dark mode.',
  theme_preview_invalid: 'The preview link has expired or is invalid. Get a new link from the panel.',
  store_domain_missing: 'The store has no storefront domain. Add one on the Stores screen.',
  color_format: 'Colour must be in #RRGGBB format (e.g. #0d5a4e).',
  content_invalid: 'The content could not be read; save it again in the editor.',
  content_unknown_node: 'The content contains an element that is not allowed (e.g. pasted HTML or a script).',
  content_invalid_link: 'Invalid link. Use https://…, mailto:, tel: or a site path starting with /.',
  content_image_alt_required:
    'Alternative text describing the image is required (for screen readers and search engines).',
  content_too_large: 'The content is too long. Split it into several pages or posts.',
  content_too_deep: 'The list is nested too deeply; at most 4 levels are allowed.',
  content_video_title_required: 'A video title is required (screen readers announce the player by it).',
  invalid_section_id: 'Invalid section id.',
  duplicate_section_id: 'The same section was added twice; reload the page and try again.',
  section_category_required: 'Choose a category for this section.',
  section_collection_required: 'Choose a collection for this section.',
  section_brand_required: 'Choose a brand for this section.',
  section_products_required: 'Choose at least one product for this section.',
  unauthenticated: 'You need to sign in.',
  invalid_credentials: 'Email or password is incorrect.',
  account_locked: 'Too many failed attempts. The account is locked for {{minutes}} minutes.',
  mfa_required: 'A verification code is required.',
  mfa_setup_required: 'You must set up two-step verification to continue.',
  mfa_invalid: 'The verification code is wrong or expired.',
  mfa_already_enrolled: 'Two-step verification is already set up.',
  mfa_enrollment_not_started: 'Start the authenticator setup first.',
  step_up_required: 'Please re-enter your verification code for this action.',
  forbidden: 'You do not have permission for this action.',
  not_found: 'Record not found.',
  merchant_market_required: 'Select at least one market.',
  translation_base_locale:
    'No translation is kept for the base language; edit the product or category fields instead.',
  market_country_mismatch:
    "The delivery address must be in the selected market's country. To ship elsewhere, choose that country at the top of the page.",
  tax_rate_missing:
    'Orders cannot be taken for this country because no VAT rate is set. Please contact the store.',
  export_exempt_domestic: 'The export exemption can only be used in a market abroad.',
  hs_code_format: 'The HS code must have 6–12 digits.',
  order_cancelled: 'This document cannot be created for a cancelled order.',
  store_not_found: 'No store is connected to this domain.',
  conflict: 'The action conflicts with an existing record.',
  version_mismatch: 'Someone else changed this record while you were editing. Refresh and try again.',
  validation_failed: 'Some fields are invalid.',
  bad_request: 'Invalid request.',
  token_invalid: 'The link is invalid or expired.',
  no_organization: 'Your account is not linked to an active business.',
  rate_limited: 'Too many requests. Please wait and try again.',
  idempotency_key_required: 'The Idempotency-Key header is required for this action.',
  idempotency_conflict: 'The same Idempotency-Key was used with a different request.',
  idempotency_in_progress: 'The same request is being processed.',
  csrf_failed: 'Security check failed. Refresh the page and try again.',
  internal: 'An unexpected error occurred. Error code: {{requestId}}',
  slug_taken: 'This short name is already in use.',
  code_taken: 'This code is already in use.',
  hostname_taken: 'This domain is registered to another store.',
  market_exists: 'This country/language/currency combination already exists.',
  cannot_remove_default_market:
    'The default market cannot be removed; make another market the default first.',
  already_member: 'This person is already a member.',
  last_owner: 'The business must keep at least one active owner.',
  role_in_use: 'This role is assigned to {{count}} users; change their role first.',
  role_name_taken: 'A role with this name already exists.',
  integration_not_available_yet:
    'This integration will be added in phase {{phase}}. Credentials cannot be entered yet.',
  integration_not_configured: 'Save the connection details first.',
  setup_step_locked: 'This step opens in phase {{phase}}.',
  invalid_email: 'Enter a valid email address.',
  file_too_large: 'File is too large (max {{maxMb}} MB).',
  file_type_not_allowed: 'This file type cannot be uploaded.',
  template_name_taken: 'A template with this name already exists.',
  sku_pattern_no_token: 'The pattern needs at least one token (e.g. {marka}).',
  sku_pattern_unknown_token: 'Unknown token. Available: {marka} {kategori} {urun} {secenek} {sira}.',
  sku_pattern_invalid: 'Only letters, digits, tokens and - _ . / are allowed.',
  schedule_in_past: 'The publish time must be at least 1 minute ahead.',
  schedule_too_far: 'Publishing can be scheduled at most 1 year ahead.',
  listing_already_published: 'The product is already published in this store.',
  bulk_too_many: 'A bulk operation can include at most {{max}} products. Narrow the filter.',
  collection_not_manual: 'Products cannot be added by hand to a rule-based collection; change its rules.',
  lot_tracked: 'This variant is tracked by lot/expiry; enter stock on the stock screen.',
  stock_below_reserved: 'Stock cannot go below the units reserved for orders.',
  lot_required: 'Stock in this warehouse is held in lots; choose the lot (or "Stock without lot").',
  import_not_finished: 'The import has not finished yet; you can retry once it does.',
  import_nothing_to_retry: 'There is nothing to retry; all products were applied.',
  import_json_invalid: 'The JSON file could not be read. Make sure it is valid JSON.',
  import_doc_field_invalid: 'This value does not match the product document schema.',
  xml_invalid: 'The XML file could not be read (format error).',
  xml_doctype_not_allowed: 'For security, XML with DOCTYPE or ENTITY declarations is not accepted.',
  column_map_invalid: 'The column mapping could not be read.',
  fx_same_currency: 'For a rate-based price the source list must be in another currency.',
  price_list_derived:
    'This list is derived from exchange rates; its prices are calculated from the base list. Change the price in the base list or switch the list back to manual prices.',
  card_currency_unsupported: '{{provider}} does not accept card payments in {{currency}}.',
  fx_base_missing: 'The base list of this rate-derived list was not found.',
  fx_rate_unavailable:
    'No CBRT rate of the selected type for {{currency}} (not fetched yet or not published for this type). Rates are never made up: choose another rate type or recalculate once rates arrive.',
  fx_list_is_base: 'Other lists are derived from this list, so it cannot be derived itself.',
  fx_not_configured: 'This list is not derived from exchange rates.',
  fx_base_self: 'A list cannot be derived from itself; choose another base list.',
  fx_base_derived: 'The base list cannot be rate-derived; choose a list with manual prices.',
  country_format: 'The country code must be two letters (e.g. DE).',
  market_currency_mismatch: 'The market currency must match the list currency.',
  rate_format: 'Enter the rate like 34.1250, greater than zero with at most 8 decimals.',
  customer_or_email_required: 'Choose a registered customer or enter an email for a guest order.',
  discount_conflict: 'A coupon and a manual discount cannot be combined; choose one.',
  draft_only_field: 'Customer, shipping, discount and payment method can only be changed on a draft order.',
  order_closed: 'The order is closed (completed or cancelled) and cannot be changed.',
  order_shipped: 'The order has shipped; items and address can no longer be changed.',
  order_paid:
    'Payment has been received; items and quantities cannot be changed. Only the address and note can.',
  order_invoiced:
    'The order has been invoiced; items and billing address cannot be changed. Cancel the invoice first.',
  order_payment_in_progress:
    'The customer is paying by card right now; items cannot be changed until the payment completes.',
  payment_link_expired: 'The payment link has expired. Contact the seller for a new link.',
  payment_link_cancelled: 'This payment link was cancelled. Contact the seller for the current link.',
  payment_link_used: 'This link has already been used to pay.',
  payment_link_closed: 'The order is no longer awaiting payment (paid or cancelled).',
  payment_link_amount_changed: 'The order total changed after the link was created; a new link is needed.',
  payment_link_not_allowed:
    'Payment links can only be created for prepaid orders (awaiting payment or draft) with a total above zero.',
  payment_link_not_found: 'Payment link not found. Make sure you copied the whole link.',
  card_payment_unavailable:
    'Card payment is not set up (Setup required): connect a payment provider under Payments → Payment settings.',
  payment_in_progress: 'A payment attempt for this order is in progress. Try again in a few minutes.',
  preauth_not_supported: 'Pre-authorization is only available with iyzico (not for {{provider}}).',
  no_authorized_payment: 'This order has no uncaptured pre-authorization.',
  exceeds_authorization:
    'The new total exceeds the amount held on the card; more than the hold cannot be charged.',
  preauth_capture_failed:
    'The pre-authorization could not be captured: {{detail}}. Check the provider panel; if needed release it and take a new payment.',
  preauth_release_failed:
    'The pre-authorization could not be released: {{detail}}. Check the provider panel.',
  release_authorization_first:
    'This order has a hold on the card: use "Release pre-authorization" to cancel it.',
  order_line_unknown: 'This item is not part of the order.',
  quantity_exceeds_remaining: 'The quantity cannot exceed the quantity still waiting to ship.',
  nothing_to_ship: 'Nothing left to ship; all items of the order have shipped.',
  partial_shipment_not_for_cod:
    'A cash-on-delivery order cannot be split: the amount to collect must travel in one package. Ship all items together.',
  order_partially_shipped:
    'Part of the order has shipped. Ship the remaining items with "Ship"; to cancel the order, cancel its shipments first.',
  exchange_not_for_withdrawal:
    'A withdrawal refunds the price; for an exchange choose defective item, wrong item or other as the reason.',
  exchange_requires_delivery: 'An exchange can be requested after the order has been delivered to you.',
  exchange_variant_invalid:
    'This option cannot be used for an exchange: choose an option of the same product at the same price.',
  exchange_out_of_stock:
    'Not enough stock for the option you chose. Choose another option or ask for a refund.',
  not_an_exchange: 'This request is not an exchange request.',
  exchange_not_approved: 'The exchange item ships only for an approved exchange request.',
  exchange_ship_required:
    'An exchange is completed with "Ship exchange": the new item leaves stock and the customer gets the tracking number.',
  partial_cancel_not_allowed:
    'Partial cancellation is only for an order that has partly shipped (processing). Cancel an order that has not shipped at all in full.',
  nothing_to_cancel: 'Nothing to cancel; no items are waiting to ship.',
  address_city_unknown: 'Province not in the list; choose it from the list.',
  address_district_unknown: 'This district does not belong to the chosen province; choose it from the list.',
  neighbourhood_unknown: 'This neighbourhood is not in the selected district; choose from the list.',
  point_outside_turkey: 'The location appears to be outside Türkiye; check the latitude and longitude.',
  sales_point_location_used: 'There is already a store entry for this location.',
  sales_point_pin_manual:
    'This listing has a manually entered pin; remove the pin first to look up the location from the address.',
  needs_finder_id_format:
    'Use lowercase letters, digits, hyphens or underscores for the ID (up to 40 characters).',
  needs_finder_duplicate_id: 'This ID is already in use; every item needs its own ID.',
  needs_finder_unknown_area:
    'The support area in the condition does not exist; add the area or remove it from the condition.',
  needs_finder_unknown_answer:
    'The question or option in the condition does not exist; choose one from the list.',
  needs_finder_product_missing: 'Product not found (it may have been deleted); choose another product.',
  needs_finder_promotion_missing:
    'Promotion not found in this store; choose an automatic promotion of this store.',
  needs_finder_draft_exists: 'This store already has a draft. Use "Regenerate draft" to replace it.',
  needs_finder_not_submitted:
    'The draft has not been submitted for review or changed after submission; submit it first.',
  needs_finder_no_areas: 'Add at least one support area.',
  needs_finder_no_rules: 'Add at least one recommendation rule.',
  needs_finder_no_emergency_option:
    'Mark at least one emergency option; in an emergency the visitor is referred to a veterinarian.',
  needs_finder_pets_disabled: 'Saving pets is turned off in this store.',
  needs_finder_pets_full: 'You can save up to 20 pets; delete one first.',
  needs_finder_consent_required: 'Tick the explicit consent box to save.',
  needs_finder_report_days: 'The period can be 7, 30 or 90 days.',
  location_not_found: 'The location does not belong to this dealer.',
  hours_overlap: 'Opening hour ranges overlap on the same day.',
  hours_range: 'Closing time must be after opening time.',
  time_format: 'Time must be HH:MM (e.g. 09:00).',
  postal_code_format: 'The postal code must be 5 digits (e.g. 34710).',
  postal_code_city_mismatch:
    'The postal code does not belong to the chosen province: its first two digits are the province code.',
  month_format: 'Month must be in YYYY-MM format (e.g. 2026-10).',
  archive_year_required: 'A year is required to choose an archive month.',
  form_field_id: 'Field ID may contain only lowercase letters, digits and underscores (max 40).',
  form_label_required: 'Enter a label for the field.',
  form_options_required: 'A choice list needs at least 2 options.',
  form_options_duplicate: 'Options must be different from each other.',
  form_too_many_fields: 'A form can have at most 20 fields.',
  form_field_duplicate: 'The same field was added twice.',
  form_email_required: 'The contact form needs a required email field so you can reply.',
  form_privacy_notice_required: 'Publish the privacy notice (KVKK) first to turn on the form (Legal texts).',
  form_disabled: 'This form is not available right now.',
  form_field_required: 'This field is required.',
  form_value_invalid: 'Enter a valid value.',
  form_value_too_long: 'The text is too long.',
  s3_endpoint_invalid: 'Object storage endpoint, bucket name or keys are missing or invalid.',
  s3_auth_failed: 'The object storage keys were rejected.',
  s3_bucket_missing: 'No object storage bucket with this name.',
  s3_unreachable: 'The object storage server could not be reached.',
  s3_verify_failed: 'The object storage test file could not be verified.',
  newsletter_unavailable: 'Newsletter sign-up is not available right now.',
  newsletter_consent_required: 'Tick the consent box to subscribe.',
  newsletter_token_invalid:
    'The confirmation link is invalid or has expired. You can subscribe again from the form.',
  unsubscribe_token_invalid: 'The link is invalid. Make sure you opened the full link from the email.',
  suppression_exists: 'This address is already on the suppression list.',
  iys_auth_failed: 'The İYS username or password was not accepted.',
  iys_invalid_settings:
    'İYS settings are incomplete: İYS code, brand code, username and password are required.',
  iys_rejected: 'İYS did not accept the record; see the İYS records list for details.',
  iys_unreachable: 'İYS could not be reached. It will be retried later.',
  segment_rules_required: 'Add at least one condition.',
  segment_condition_invalid: 'The condition is incomplete or invalid: check the field, comparison and value.',
  segment_limit: 'You can create up to {{max}} segments. Delete the ones you no longer use.',
  segment_name_taken: 'A segment with this name already exists.',
  email_provider_not_live:
    'This provider is not connected. Enter its details in Integrations and test the connection first.',
  ses_invalid_settings: 'Amazon SES settings are incomplete.',
  ses_auth_failed: 'Amazon access keys were not accepted.',
  ses_unreachable: 'Amazon SES could not be reached.',
  ses_sending_disabled: 'Sending is disabled on the Amazon SES account.',
  sendgrid_invalid_settings: 'SendGrid settings are incomplete.',
  sendgrid_auth_failed: 'The SendGrid API key was not accepted.',
  sendgrid_missing_scope: 'The SendGrid API key cannot send mail.',
  sendgrid_unreachable: 'SendGrid could not be reached.',
  postmark_invalid_settings: 'Postmark settings are incomplete.',
  postmark_auth_failed: 'The Postmark server token was not accepted.',
  postmark_unreachable: 'Postmark could not be reached.',
  email_link_invalid: 'Invalid link. Use a store path (/campaign) or a full address starting with http(s).',
  email_block_duplicate: 'The same block was added twice; reload the page and try again.',
  test_recipient_not_staff:
    'Test emails can be sent only to panel users of your business (up to 5 addresses). Leave empty to send to yourself.',
  email_not_configured:
    'Email sending is not set up (Setup required): connect SMTP or an email provider under Connections.',
  email_image_unavailable: 'The image was not found or cannot be used; upload it again.',
  email_products_source_missing:
    'The selected product, collection or category was not found; choose the source again.',
  campaign_audience_empty: 'Choose at least one segment or add newsletter subscribers.',
  campaign_segment_missing:
    'One of the chosen segments was not found (it may have been deleted); reload the list.',
  campaign_template_invalid: 'Choose an email template of this store.',
  campaign_subject_b_required: 'Write subject B for the A/B test.',
  campaign_not_editable: 'Only a draft campaign can be changed.',
  campaign_not_deletable: 'A campaign that started sending cannot be deleted; its report stays on record.',
  campaign_not_cancellable: 'Sending of this campaign has already finished or stopped.',
  campaign_not_paused: 'The campaign is not paused.',
  campaign_schedule_invalid: 'The send time must be after now and at most 90 days ahead.',
  campaign_no_recipients:
    'Nobody in this audience can receive it (after suppression, consent and İYS checks).',
  template_review_required:
    'The template has health claims awaiting expert approval; it cannot be sent until approved.',
  automation_email_required: 'The flow needs at least one email step.',
  automation_wait_last: 'A flow cannot end with a wait step; remove it or add an email after it.',
  automation_condition_invalid: 'This condition cannot be used in this flow.',
  automation_template_required: 'Choose a template for this email step to turn the flow on.',
  birthday_invalid: 'That month has no such day.',
  template_unavailable: 'The template is unavailable (deleted or awaiting expert approval).',
  frequency_cap: 'The person recently received another marketing email (frequency cap).',
  stock_alerts_unavailable: '"Notify me" is not used in this store.',
  stock_alert_in_stock: 'This option is in stock now; you can add it to the cart.',
  stock_alert_not_waiting: 'This request is no longer waiting (notified or closed).',
  price_drop_store_required: 'Choose the store whose prices and links are used for price drop notices.',
  products_unavailable: 'The products could not be shown in the email (unpublished or awaiting approval).',
  expired: 'Expired.',
  suppressed: 'The address is suppressed.',
  panel: 'Cancelled in the panel.',
  rejected: 'The email provider rejected the message.',
  sms_template_in_use:
    'This SMS template is used by a pending campaign; delete the campaign or choose another template first.',
  sms_not_configured:
    'No SMS provider connected (setup required): connect Netgsm, İleti Merkezi or Verimor in Integrations and choose it in SMS and WhatsApp settings.',
  sms_mersis_required: 'Commercial SMS needs a MERSİS number: enter it in business details.',
  sms_opt_out_required: 'Commercial SMS needs an opt-out text: enter it in SMS and WhatsApp settings.',
  sms_provider_not_connected:
    'This SMS provider has no live connection: connect and test it in Integrations first.',
  sms_template_required: 'Choose an SMS template.',
  whatsapp_not_configured: 'WhatsApp Business is not connected (setup required): connect it in Integrations.',
  whatsapp_unreachable: 'Could not reach WhatsApp (Meta). Try again later.',
  whatsapp_auth_failed: 'The WhatsApp access token was rejected: renew it in Integrations.',
  whatsapp_template_not_approved: 'This WhatsApp template was not found in Meta or is not approved.',
  whatsapp_template_health_claim:
    'The WhatsApp template or its variables contain a health claim; it cannot be sent with this text.',
  whatsapp_template_required: 'Choose a WhatsApp template or type its name and language.',
  whatsapp_params_mismatch: 'The number of variables must match the template.',
  firebase_not_configured:
    'Firebase is not connected (setup required): connect the Firebase service account in Integrations.',
  firebase_auth_failed: 'The Firebase service account was rejected: renew it in Integrations.',
  no_devices: 'No devices for this account; turn on notifications in the Android admin app first.',
  quiet_hours_invalid: 'Quiet hours must start and end at different times.',
  web_push_key_required: 'Create the notification key first.',
  web_push_key_exists: 'A key already exists; use "Replace key" to renew it (subscriptions end).',
  web_push_unavailable: 'Browser notifications are not available for this store right now.',
  web_push_not_configured:
    'Storefront notifications are not set up (setup required): create the key and turn the setting on.',
  push_contact_required: 'A contact address is needed to turn notifications on.',
  push_contact_invalid: 'The contact address must start with mailto: or https://.',
  push_endpoint_invalid: 'The browser’s push address is not supported.',
  push_keys_invalid: 'The browser’s push keys are invalid.',
  push_url_invalid: 'Write a store path starting with / (e.g. /kategori/kedi).',
  promotion_tiers_invalid: 'Tier thresholds must differ; quantity tiers start at 1.',
  promotion_pay_invalid: '"Pay" must be less than "buy" (e.g. buy 3 pay 2).',
  promotion_currency_required: 'Choose a currency for a promotion with amounts.',
  promotion_not_editable: 'A live promotion cannot be changed; pause it first.',
  promotion_not_deletable:
    'A promotion that has gone live is kept (price history and reports); you can pause it.',
  promotion_status_invalid: 'The promotion is not in a state that allows this.',
  promotion_ended: 'The promotion end date has passed; update the dates.',
  coupon_not_combinable: 'This coupon cannot be combined with the promotion in your cart.',
  order_promotions_locked:
    'Items of an order with automatic promotions cannot be changed; cancel the order and create a new one.',
  gift_card_balance_negative: 'The balance cannot go below zero.',
  store_credit_insufficient: 'Not enough store credit.',
  gift_card_not_found: 'Gift card not found or not usable. Check the code.',
  gift_card_expired: 'This gift card has expired.',
  gift_card_currency: 'This gift card is not in this store’s currency.',
  gift_card_empty: 'This gift card has no balance left.',
  store_credit_login_required: 'Sign in to use your store credit.',
  gift_card_balance_changed: 'The gift card balance changed. Check the amount to pay and try again.',
  store_credit_balance_changed: 'Your store credit changed. Check the amount to pay and try again.',
  gift_card_missing: 'The gift card record for this payment was not found.',
  store_credit_no_customer: 'Store credit can only be given to a registered customer (guest order).',
  date_in_past: 'The date must be in the future.',
  not_zero: 'The amount cannot be zero.',
  refund_order_not_paid:
    'The order is not fully paid. Cancel the order instead of refunding; the gift card/credit balance is restored automatically.',
  store_credit_not_for_withdrawal:
    'A withdrawal refund must go back to the customer’s payment method; it cannot be given as store credit.',
  store_credit_consent_required: 'The customer’s explicit consent is required to refund as store credit.',
  loyalty_points_insufficient: 'Not enough points (available: {{points}} points).',
  loyalty_points_limit: 'The points balance would exceed the limit.',
  loyalty_tier_name_duplicate: 'This tier name is used by another tier.',
  loyalty_tier_spend_duplicate: 'Two tiers cannot have the same spend threshold.',
  loyalty_nothing_to_offer: 'To turn the program on, set an earning rate or at least one tier.',
  loyalty_login_required: 'Sign in to use points.',
  loyalty_unavailable: 'Loyalty points cannot be used for this order.',
  loyalty_min_redeem: 'You do not have enough points to use them yet.',
  loyalty_points_changed: 'Your points balance changed; check the amount and confirm again.',
  order_loyalty_locked:
    'Products of an order with a loyalty tier discount cannot be changed; cancel and recreate the order.',
  referral_self: 'You cannot use your own invite code.',
  referral_not_first_order: 'The invite code can only be used on a first order.',
  referral_percentage_max: 'The referral discount can be at most 50%.',
  referral_unavailable: 'The referral program is not available right now.',
  referral_code_failed: 'The invite code could not be created; please try again.',
  affiliate_source_format:
    'The source must use lowercase letters, digits, hyphens or underscores (2–40 characters).',
  affiliate_discount_taken: 'This coupon is linked to another partner.',
  affiliate_source_taken: 'This source is used by another partner.',
  commission_not_approved: 'Only approved commissions can be marked as paid.',
  ticket_number_failed: 'Could not assign a request number; please try again.',
  ticket_agent_invalid:
    'Requests can only be assigned to an active staff member who can reply to support requests.',
  ticket_closed: 'This request is closed; replies are not accepted. You can open a new request.',
  ticket_email_required: 'The message has no email address; it cannot be converted to a request.',
  ticket_already_created: 'This message was already converted to request #{{number}}.',
  ticket_order_not_found: 'This order was not found in your account.',
  ticket_not_resolved: 'You can rate the request after it is resolved.',
  ticket_already_rated: 'You have already rated this request.',
  macro_title_taken: 'A saved reply with this name already exists.',
  support_report_days: 'The period can be 7, 30, 90 or 365 days.',
  chat_privacy_notice_required: 'Publish the privacy notice before turning on live chat.',
  chat_unavailable: 'Live support is not available right now.',
  chat_offline: 'No agent is online right now; you can leave a message.',
  chat_closed: 'This chat has ended. You can start a new chat.',
  chat_taken: 'Another staff member has taken this chat.',
  chat_ticket_exists: 'This chat was already converted to a support request.',
  chat_empty: 'The chat has no visitor message; it cannot be converted.',
  ads_utm_source_format:
    'Source must be 2–40 characters: lowercase letters, digits, dot, dash and underscore only.',
  ads_currency_unsupported: 'This currency is not supported.',
  ads_account_exists: 'An ad account with this ID already exists on this platform.',
  ads_import_columns:
    'Required columns not found in the file: {{columns}}. Date, campaign and spend columns are required.',
  ads_no_live_source: 'No live ad connection. Set up Meta or TikTok on the Connections page.',
  ads_report_days: 'Period can be 7, 30 or 90 days.',
  ads_change_value_required: 'Enter an amount for a budget change or choose a status for a delivery change.',
  ads_change_not_pending: 'This request is no longer pending.',
  ads_change_not_approved: 'Only an approved request can be marked as applied.',
  ads_change_self_approval: 'You cannot approve your own request; another authorised user must approve it.',
  google_ads_conversion_action_format:
    'The conversion action must look like customers/1234567890/conversionActions/123.',
  google_ads_cloud_project_not_approved:
    'Your Google Cloud project can only access test accounts with the Google Ads API (Test access). For a real ad account, apply for Explorer access in Google Cloud: Google Cloud Console → Google Ads API → Overview (the project of the OAuth client used for the Google connection).',
  google_ads_user_permission_denied:
    'The connected Google account cannot access this Google Ads account. If you access it through a manager (MCC) account, enter the MCC ID under Integrations → Google Ads; if you did, check that it manages this account.',
  google_ads_customer_not_enabled: 'This Google Ads account is not enabled yet or has been closed.',
  google_ads_authorization_error:
    "Google Ads rejected the authorization. If the Cloud project's access level was upgraded after 9 September 2026, this may be a known issue reported by Google: create a new Google Cloud project and apply for Explorer access.",
  google_ads_api_not_enabled:
    'The Google Ads API is not enabled in the Google Cloud project or its terms of service were not accepted. Enable the Google Ads API in the Google Cloud Console.',
  google_ads_quota_exceeded:
    'Google Ads API request limit reached. Explorer access has a daily operation limit on real accounts; the operation is retried automatically later.',
  google_ads_access_prohibited:
    'Google Ads API access is blocked for this Google Cloud project. Check the Google Ads API access level in Google Cloud Console.',
  google_ads_action_not_permitted:
    'The connected Google account is not allowed to do this in this Google Ads account (it may have read-only access). Connect with Standard or Admin access.',
  google_ads_account_suspended:
    'The Google Ads account is suspended; no changes can be made. Check the account status in Google Ads.',
  google_ads_not_allowlisted:
    'This Google Ads feature is not available for your account (Google allowlist required).',
  google_ads_policy_violation:
    'Rejected under Google advertising policy. Edit the text or product; health products must not use claims like "treats", "prevents" or "cures". Details are in the campaign policy status.',
  google_ads_budget_too_low: 'The daily budget is too low for Google Ads. Enter a higher daily budget.',
  google_ads_budget_too_high: 'The daily budget exceeds the Google Ads maximum.',
  google_ads_budget_currency: "The budget amount does not match the account's currency or its smallest unit.",
  google_ads_budget_invalid:
    'Google Ads rejected the budget setting. Check that the budget is not used by another campaign and has not been removed.',
  google_ads_duplicate_name: 'A campaign or budget with this name already exists. Enter a different name.',
  google_ads_bid_out_of_range: 'The bid is outside Google Ads limits.',
  google_ads_bidding_invalid:
    'The selected bidding strategy cannot be used with this campaign type or budget.',
  google_ads_temporary_error:
    'Google Ads returned a temporary error. The operation is retried automatically shortly.',
  google_ads_resource_not_found:
    'The resource was not found in Google Ads (it may have been removed in Google Ads). Sync and try again.',
  google_ads_value_out_of_range: 'The value is outside Google Ads limits.',
  google_ads_resource_limit:
    'The Google Ads account has reached a resource limit (e.g. number of campaigns or assets).',
  google_ads_request_rejected: 'Google Ads rejected the request. See the Google connection log for details.',
  google_ads_conversion_action_required: 'Enter the conversion action to turn on conversion uploads.',
  google_ads_not_linked:
    'No Google Ads account is linked to this store. Choose the store’s Google Ads account on the Google connections page.',
  google_ads_merchant_link_missing:
    'The Merchant Center account and the Google Ads account are not linked. Request the link in Merchant Center and approve it in Google Ads.',
  google_ads_purchase_conversion_missing:
    'The Google Ads account has no active primary “Purchase” conversion. Campaigns optimise for purchases; set up conversion tracking first.',
  google_ads_campaign_removed: 'The campaign was removed and can no longer be changed.',
  google_ads_not_draft: 'Only a draft campaign can be edited or deleted.',
  google_ads_operation_open: 'This campaign has a pending change. Wait for its result or cancel it first.',
  google_ads_already_created: 'The campaign has already been created in Google Ads.',
  google_ads_not_created:
    'The campaign has not been created in Google Ads yet. Send the draft for approval first.',
  google_ads_already_enabled: 'The campaign is already live.',
  google_ads_not_enabled: 'The campaign is not live.',
  google_ads_bidding_not_for_kind: 'This bid strategy cannot be used with this campaign type.',
  google_ads_target_not_for_bidding: 'This target cannot be used with the selected bid strategy.',
  google_ads_end_before_start: 'The end date cannot be before the start date.',
  google_ads_no_change: 'The value is already the same; nothing to change.',
  google_ads_operation_not_pending: 'This change is no longer waiting for approval.',
  google_ads_self_approval:
    'You cannot approve your own request; another approver or the business owner must approve it.',
  google_ads_monthly_cap_missing:
    'No monthly ad budget cap is set. Changes that can spend money cannot be approved until a cap is set.',
  google_ads_monthly_cap_exceeded:
    'The estimated monthly maximum exceeds the monthly ad budget cap. Lower the budget or raise the cap.',
  google_ads_no_products: 'The campaign has no products. Add products before going live.',
  google_ads_goal_not_applied:
    'The campaign’s “Purchase” conversion goal has not been applied yet. Try again in a few minutes.',
  google_ads_operation_not_open: 'This change cannot be cancelled: it is being applied or has finished.',
  google_ads_no_drift: 'There is no difference from Google Ads.',
  google_ads_recommendation_invalid: 'Invalid Google recommendation.',
  google_ads_country_unsupported: 'This country is not in the targeting list.',
  google_ads_language_unsupported: 'This language is not in the targeting list.',
  google_ads_daily_limit:
    'Today’s Google Ads API operation limit has been reached; the change will be applied tomorrow morning.',
  google_ads_apply_interrupted:
    'Applying was interrupted. Check whether the campaign exists in Google Ads; if not, request it again.',
  google_ads_verify_mismatch:
    'The change was sent to Google Ads, but the value read back differs from the expected one. See the difference on the campaign page.',
  google_ads_invalid_status_change:
    'This status change is not allowed in Google Ads (for example, a removed campaign cannot be reopened).',
  google_ads_date_in_past: 'A date in the past cannot be selected.',
  google_ads_start_date_locked: 'The start date of a campaign that has already started cannot be changed.',
  google_ads_recommendation_stale:
    'This Google recommendation is no longer valid (applied, dismissed or updated).',
  google_ads_basic_access_required:
    'Keyword ideas need Basic access to the Google Ads API. Google disables planning services on Explorer access; get Basic approval from Google, then set the access level to “Basic” in the Google Ads settings.',
  google_ads_ad_rejected:
    'Google Ads rejected the ad text (character limit, number of headlines/descriptions or final URL). Edit the text and request again.',
  google_ads_keyword_rejected:
    'Google Ads rejected a keyword (too long, too many words or invalid characters). Edit the list and request again.',
  google_ads_final_url_invalid: 'The final URL must be a valid address starting with https://.',
  google_ads_final_url_not_store:
    'The final URL must be on the store’s own domain (for example a product or category page).',
  google_ads_search_only: 'Ad text and keywords are only used in Search campaigns.',
  google_ads_search_no_products:
    'Products are not added to Search campaigns; they run on ad text and keywords.',
  google_ads_keywords_min: 'Add at least one keyword.',
  google_ads_keywords_max: 'Too many keywords.',
  google_ads_not_search: 'This action is only available for Search campaigns.',
  google_ads_no_keywords: 'The campaign has no keywords. Add keywords before going live.',
  google_ads_source_not_listed: 'The selected product or category is not live in this store.',
  google_ads_source_not_reviewed:
    'This product’s health content is not vet-approved, so no ad draft is generated. Send the product text for review first.',
  google_ads_ideas_seed_required: 'Enter at least one word or a landing page to get ideas.',
  google_ads_text_review_not_pending: 'This ad text is not waiting for review.',
  google_ads_headline_too_long: 'A headline can have at most 30 characters.',
  google_ads_description_too_long: 'A description can have at most 90 characters.',
  google_ads_headlines_min: 'Enter at least 3 headlines.',
  google_ads_headlines_max: 'There can be at most 15 headlines.',
  google_ads_descriptions_min: 'Enter at least 2 descriptions.',
  google_ads_descriptions_max: 'There can be at most 4 descriptions.',
  google_ads_path_too_long: 'A display path part can have at most 15 characters.',
  google_ads_path_invalid: 'The display path can only contain letters, digits and hyphens.',
  google_ads_path2_without_path1: 'Enter the first path part before the second.',
  google_ads_text_duplicate: 'The same text cannot be used twice.',
  google_ads_too_many_pins:
    'Too many headlines are pinned: keep at least two unpinned so Google can vary them.',
  google_ads_keyword_too_long: 'A keyword can have at most 80 characters.',
  google_ads_keyword_too_many_words: 'A keyword can have at most 10 words.',
  google_ads_keyword_invalid_chars:
    'The keyword contains a character Google does not accept (such as ! @ % , * ?).',
  google_ads_keyword_duplicate: 'This keyword is already in the list with the same match type.',
  google_not_linked: 'No Google resource is linked to this store. Choose one on the Google connections page.',
  ga4_report_days: 'Period can be 7, 28 or 90 days.',
  retention_confirm_required:
    'To turn on automatic destruction, confirm that expired records will be permanently deleted.',
  retention_days_range: 'The period must be within the allowed range for this data type.',
  retention_log_days: 'Period can be 30, 90, 365 or 1095 days.',
  merchant_performance_days: 'Period can be 7, 28 or 90 days.',
  custom_event_name:
    'Event name must start with a lowercase letter; only a–z, digits and underscore (3–40 characters).',
  custom_event_reserved: 'This name is reserved or used by a standard event; choose another name.',
  custom_event_path:
    'Page path must start with / (e.g. /campaign/october); add * at the end to match the beginning.',
  custom_event_path_required: 'Enter the page path for a page view event.',
  custom_event_destinations: 'Choose at least one measurement service.',
  custom_event_duplicate: 'The same event is defined twice.',
  storage_permission_denied:
    'The file could not be saved: no write permission on the server file storage. Tell your system administrator (error code {{requestId}}).',
  storage_disk_full:
    'The file could not be saved: the server disk is full. Tell your system administrator (error code {{requestId}}).',
  storage_read_only:
    'The file could not be saved: the server file storage is mounted read-only. Tell your system administrator (error code {{requestId}}).',
  storage_remote_failed:
    'The file could not be saved: writing to the connected object storage (S3/R2) failed. Test the connection under Integrations → Object storage (error code {{requestId}}).',
  storage_write_failed:
    'The file could not be saved: writing to file storage failed. Tell your system administrator (error code {{requestId}}).',
  live_sandbox_skip_owner_only: 'Only the business owner can approve going live without a test payment.',
  review_not_purchased: 'You can review this product only after buying it from this store and receiving it.',
  review_already_submitted: 'You have already reviewed this product.',
  review_too_short: 'A review must be at least 20 characters.',
  review_rating_required: 'Choose a rating from 1 to 5.',
  pdf_active_content:
    'This PDF contains active content (JavaScript, embedded files or program launch) and cannot be published. Re-save it with "Print to PDF" and upload again.',
  video_url_invalid: 'Video address not recognised. Paste a YouTube or Vimeo video address.',
  video_duplicate: 'This video is already added.',
  document_file_invalid: 'Document file not found or not a PDF; upload it again.',
  document_duplicate: 'This document is already added.',
  complementary_self: 'A product cannot complement itself.',
  password_too_short: 'Password must be at least 12 characters.',
  password_too_long: 'Password is too long.',
  password_too_common:
    'This password is too common or easy to guess (it appears in leaked password lists or contains your name); choose a longer one made of several words and numbers.',
  password_contains_email: 'Password must not contain your email address.',
  required: 'This field is required.',
  in_past: 'The date cannot be in the past.',
  import_already_applied: 'This import has already been applied.',
  import_preview_expired: 'The preview has expired (1 hour). Upload the file again.',
  import_file_missing: 'Choose a file.',
  import_file_too_large: 'The file is too large (max {{maxMb}} MB).',
  import_file_unreadable: 'The file could not be read. Upload a CSV or Excel (.xlsx) file.',
  import_xls_unsupported: 'The old Excel format (.xls) is not supported. Save the file as .xlsx or CSV.',
  import_file_empty: 'The file has no data (the first row must be the header).',
  import_too_many_rows: 'The file can have at most {{max}} rows; split it.',
  column_missing: 'Required column missing: {{column}}',
  dealer_key_column_missing:
    'At least one of the "Dealer Code" or "Tax No" columns is required (for matching).',
  masked_value:
    'Masked values (containing ***) cannot be imported. Export with permission to view personal data unmasked, or leave the cell empty.',
  dealer_key_required: 'This row has no dealer code or tax number.',
  dealer_conflict: 'The dealer code and tax number point to two different dealers.',
  dealer_group_required: 'An approved dealer needs a dealer group (dealer prices come from this group).',
  dealer_group_unknown: 'There is no dealer group with this name.',
  dealer_code_taken: 'This dealer code is already used by another company.',
  tax_number_registered: 'A company with this tax number already exists.',
  tax_number_invalid: 'The tax number (10 digits) or national ID (11 digits) is invalid.',
  tax_number_format: 'The tax number format is invalid.',
  phone_format: 'The phone number is invalid (e.g. +90 532 123 45 67).',
  email_format: 'The email address is invalid.',
  invalid_status_transition: 'This status change is not allowed.',
  application_already_decided: 'This application has already been decided.',
  application_pending: 'You already have an application under review.',
  already_dealer: 'Your account is already linked to a dealer company.',
  company_exists:
    'We already have a dealer with this tax number. Ask your company admin to add you, or contact us.',
  note_required: 'A note is required.',
  payment_note_required:
    'Describe how the payment was received (e.g. bank transfer reference, open account).',
  consent_proof_required: 'Enter a document/text reference for the consent (e.g. signed form no).',
  customer_disabled: 'The customer account is disabled.',
  customer_anonymized:
    "This customer's personal data was anonymized after an erasure request; the account cannot be edited or reopened.",
  privacy_export_limit: 'You can download your data at most 5 times in 24 hours. Please try again later.',
  privacy_request_open:
    'You already have an open erasure request; you will be notified by email when it is resolved.',
  privacy_not_erasure: 'Anonymization is only done for erasure requests.',
  privacy_request_closed: 'The request is already resolved.',
  privacy_already_anonymized: "This person's data is already anonymized.",
  privacy_store_credit_balance:
    'The customer has store credit ({{balances}}). Pay it out or set it to zero with the customer’s consent (Customers → Store credit) before erasing.',
  privacy_subject_not_found:
    'No customer account or order with this email; there is no data to anonymize. Resolve the request with a note.',
  privacy_open_orders:
    '{{count}} order(s) are not closed ({{numbers}}). Anonymization is possible after they are delivered and closed or cancelled.',
  privacy_open_returns: '{{count}} return request(s) are open; resolve them first.',
  privacy_erasure_not_done:
    'An erasure request is resolved only by anonymization. If it cannot be erased for legal reasons, reject it with the reason.',
  privacy_confirm_mismatch: "The typed email does not match the requester's email.",
  date_in_future: 'The date cannot be in the future.',
  domain_invalid: 'Enter a valid domain (e.g. example.com).',
  dkim_selector_invalid: 'A DKIM selector may contain only letters, digits, dots, hyphens and underscores.',
  date_too_old: 'The date cannot be more than a year ago.',
  email_registered: 'An account with this email already exists. Sign in or reset your password.',
  account_activation_required:
    'Your account for this email was created by the store. Use "Forgot password" to set your password.',
  password_incorrect: 'The current password is incorrect.',
  address_limit: 'You can save at most {{max}} addresses.',
  file_invalid: 'Document not found; upload it again.',
  option_names_mismatch: "The option names in the file differ from the product's existing options.",
  title_required_for_new:
    'A new product needs "Ürün Adı" (product name); this SKU is not in the system. Update files must use existing SKUs.',
  wrong_file_products:
    'This file looks like a product list. Upload products under Catalog → Import / export → "Products".',
  wrong_file_dealers:
    'This file looks like a dealer list. Upload dealers under Catalog → Import / export → "Dealer list".',
  wrong_file_redirects:
    'This file looks like a redirect list. Upload redirects under Business → Redirects → "Import from file".',
  sku_missing:
    'SKU is empty. Enter a SKU in the file or use "Preview again with suggested SKUs" to use the suggestion in brackets.',
  sku_generated: 'SKU suggested',
  media_not_failed: 'This image is not in the "Download failed" state.',
  wrong_file_categories:
    'This file looks like a category list. Upload categories under Catalog → Import / export → "Categories".',
  category_parent_unknown:
    'Parent category not found (no category with this name/slug in the file or the system).',
  category_parent_ambiguous: 'Several categories have this name; write the parent by its slug.',
  category_parent_has_errors: 'The parent category row has an error; this row is not applied either.',
  category_status_unknown: 'Status must be "etkin" (active) or "gizli" (hidden).',
  category_changed_during_import: 'A category was deleted after the preview; upload the file again.',
  category_will_create: 'Category will be created',
  store_archive_live:
    'A live store cannot be archived directly; put it in maintenance or return it to preview first.',
  store_archived: 'The store is archived; unarchive it first (it returns to preview).',
  store_not_draft: 'A live or maintenance store cannot be deleted.',
  store_has_orders: 'This store has orders and cannot be deleted. You can archive it.',
  store_has_scoped_access:
    'Some users, invitations or API keys are limited to this store only; change their store scope first.',
  confirm_code_mismatch: 'The code does not match the store code.',
  transfer_source_empty:
    'The source warehouse has no transferable stock of this product. Use "Stock movement" → "Receipt" for the first stock entry.',
  transfer_lot_required: 'Stock in this warehouse is held in lots; choose the lot as the source.',
  migration_package_invalid:
    'The file is not a migration package or is corrupted. Upload the ZIP downloaded with "Download migration package" on staging.',
  migration_package_too_large: 'The package is too large (at most 300 MB uncompressed).',
  migration_file_missing: 'An image is missing from the package ({{file}}); download the package again.',
  migration_file_corrupt: 'An image in the package is corrupted ({{file}}); download the package again.',
  store_scope_exceeds:
    'You cannot go beyond your own store scope: you can only grant the stores you are authorised for and manage users in those stores.',
  member_self_update:
    'You cannot change your own role or store/dealer scope; another administrator must do it.',
  migration_file_type:
    'A file in the package has a type that is not allowed or content that does not match its type ({{file}}); only images and PDFs are moved.',
  product_without_variant: 'The product has no valid variant (SKU) row.',
  sku_belongs_to_other_product: 'This SKU belongs to another product.',
  brand_required: 'A brand is required (in the column or as the default brand).',
  brand_unknown: 'There is no brand with this name.',
  category_unknown: 'There is no category with this name; the product was added without it.',
  species_unknown:
    'Unknown species. Use: cat, dog, bird, rodent (hamster), rabbit, reptile (turtle), exotic or all; separate several with commas.',
  tax_class_unknown: 'No tax class with this rate; create it first.',
  visibility_unknown: 'Visibility must be "all", "retail" or "dealer".',
  image_url_invalid: 'The image address must start with https://.',
  duplicate_in_file: 'This value also appears in row {{row}} of the file.',
  amount_format: 'The amount could not be read (e.g. 1,299.90).',
  number_format: 'The number could not be read.',
  currency_unknown: 'The currency could not be determined.',
  status_unknown: 'Status must be "Approved", "Applied" or "Suspended".',
  too_long: 'The text is too long.',
  too_many: 'Too many values (at most {{column}}).',
  options_required_for_multiple_variants: 'Multiple variants need an option (e.g. Size).',
  name_taken: 'This name is already in use.',
  category_cycle: 'A category cannot be moved under its own subcategory.',
  category_has_children: 'A category with subcategories cannot be deleted.',
  product_requires_active_variant: 'An active product needs at least one active variant.',
  vet_review_not_required: 'This product has no health content; no vet review is needed.',
  content_changed_during_review:
    'The content changed while you were reviewing. Refresh and review the current content.',
  cannot_publish: 'The product cannot be published: {{reasons}}',
  invalid_option: 'The option value must be one of the defined values.',
  duplicate_combination: 'Two variants cannot have the same option combination.',
  mismatch: 'The list is out of date; refresh the page.',
  slug_format: 'The short name can contain only lowercase letters, digits and hyphens.',
  sku_format: 'SKU can contain only letters, digits and . _ - /',
  barcode_format: 'The barcode must be 8–14 digits.',
  sku_taken: 'This SKU is used by another variant.',
  store_not_ready: 'The store has no sales market (currency) yet.',
  cart_line_limit: 'The cart can contain at most {{max}} different products.',
  variant_not_sellable: 'This product cannot be purchased right now.',
  insufficient_stock: 'Not enough stock (at most {{available}}).',
  cart_empty: 'Your cart is empty.',
  empty: 'Your cart is empty.',
  cart_has_problems:
    'Some items in the cart are unavailable, out of stock or do not meet the dealer quantity rule; update the cart.',
  payment_setup_required: 'No payment method is set up yet (setup required). Please contact us to order.',
  login_required: 'Sign in or create an account to place an order.',
  dealer_only: 'Currently only our dealers can place orders.',
  checkout_not_allowed: 'The order cannot be placed right now.',
  cart_changed: 'The cart total changed (see the new total). Check and confirm again.',
  refund_required: 'A paid order cannot be cancelled without a refund.',
  length: 'Invalid text length.',
  discount_code_taken: 'This coupon code already exists.',
  discount_code_format: 'Coupon codes are 3–32 characters: letters, digits, - and _.',
  percentage_max: 'A percentage discount cannot exceed 100%.',
  currency_required: 'Choose a currency for a fixed-amount coupon.',
  ends_before_start: 'The end must be after the start.',
  discount_not_found: 'The coupon code is invalid.',
  discount_not_started: 'This coupon is not valid yet.',
  discount_expired: 'This coupon has expired.',
  discount_usage_limit: 'This coupon has reached its usage limit.',
  discount_currency: 'This coupon is not valid for your cart currency.',
  discount_not_eligible: 'This coupon is not valid for your account.',
  discount_min_subtotal: 'The cart total is too low for this coupon.',
  smtp_invalid_settings: 'SMTP settings are missing or invalid.',
  error_tracking_invalid_dsn: 'Invalid error tracking DSN.',
  error_tracking_failed: 'The error tracking service did not accept the test event.',
  observability_invalid: 'The collector address or auth headers are invalid.',
  observability_failed: 'The collector did not accept the test batch.',
  image_width: 'Unsupported image width (160, 320, 480, 640, 960 or 1280).',
  smtp_private_host_blocked: 'Cannot connect to an SMTP server on a private network address.',
  smtp_failed: 'The SMTP connection failed.',
  number: 'Enter a number.',
  unknown_field: 'Unknown field.',
  not_supported: 'This option is not supported.',
  non_zero_integer: 'Enter a non-zero whole number.',
  inactive: 'The record is inactive.',
  only_on_receipt: 'Lots can be created only on receipt.',
  must_be_positive: 'Enter a positive number.',
  must_be_non_negative: 'Enter a non-negative number.',
  same_warehouse: 'The source and target warehouses cannot be the same.',
  code_format: 'Invalid code format.',
  date_format: 'The date must be in YYYY-MM-DD format.',
  etbis_url_invalid:
    'The ETBİS link must be an address of the Ministry of Trade ETBİS site (https://etbis.eticaret.gov.tr/… or https://etbis.ticaret.gov.tr/…).',
  days_pair_required: 'Enter both the minimum and maximum time.',
  days_range_invalid: 'The minimum cannot be greater than the maximum.',
  crawl_in_progress: 'A crawl is already queued or running for this store.',
  gtm_id_invalid: 'The Google Tag Manager ID must look like GTM-XXXXXXX.',
  ga4_id_invalid: 'The GA4 measurement ID must look like G-XXXXXXXXXX (legacy UA- IDs are not supported).',
  google_ads_id_invalid: 'The Google Ads ID must look like AW-123456789.',
  google_ads_label_invalid:
    'The conversion label may contain only letters, digits, - and _ (6–40 characters).',
  google_ads_id_required: 'Enter the Google Ads ID before the conversion label.',
  meta_pixel_id_invalid: 'The Meta pixel ID contains digits only (8–20).',
  tiktok_pixel_id_invalid: 'The TikTok pixel ID has 10–30 letters and digits.',
  consent_action_mismatch: 'The cookie choices do not match the button used.',
  google_client_not_configured:
    'The Google OAuth client is not set up or has not passed its test (Setup required). Integrations → Google account (OAuth client).',
  google_not_connected: 'No Google account is connected.',
  google_client_invalid: 'Google did not accept the client ID or secret.',
  google_client_invalid_format:
    'The client ID must end with ".apps.googleusercontent.com"; the secret cannot be empty.',
  google_reconnect_required:
    'Google access is no longer valid (removed or expired). Reconnect on the Google screen.',
  google_signin_needs_domain:
    "Setup required: the test uses the store's real redirect URI. Add a storefront domain under Stores first.",
  google_invalid_request:
    "Google rejected the request (invalid_request): {{description}} Redirect URI tried: {{redirectUri}}. It must be a real https domain and listed among the client's authorized redirect URIs in Google Cloud.",
  google_redirect_uri_mismatch:
    "The redirect URI isn't registered on the client in Google Cloud (redirect_uri_mismatch): {{redirectUri}}. Add it under Google Auth Platform → Clients → client → Authorized redirect URIs. {{description}}",
  google_client_rejected: 'Google rejected the request ({{error}}): {{description}}',
  google_unreachable: 'Google could not be reached. Try again later.',
  google_state_invalid:
    'The Google response is invalid or expired (the user who started must finish within 10 minutes). Connect again.',
  google_consent_denied: 'Access was not granted on the Google consent screen; nothing changed.',
  google_auth_failed:
    'The Google connection could not be completed. Try again; if it persists, check the log.',
  google_scope_missing:
    'Google permission was not granted for this service. Reconnect with the service selected.',
  google_api_error: 'The Google service rejected the request or did not respond. Check the log.',
  google_permission_denied:
    'The connected Google account has no access to this resource. Check that the resource (property, site, account) is shared with this Google account, or reconnect with an account that has access.',
  google_api_not_enabled:
    "This Google service's API is not enabled in the Google Cloud project. Enable it in Google Cloud Console → APIs & Services → Library (the project of the OAuth client used for the Google connection).",
  google_quota_exceeded: 'Google request limit reached. Try again shortly; syncs are retried automatically.',
  google_resource_not_accessible: 'This resource is not in the list the connected Google account can access.',
  store_has_no_domain: 'The store has no storefront domain. Add one on the Stores screen.',
  attribution_days: 'The period must be 7, 30, 90 or 365 days.',
  keyword_exists: 'This keyword is already in the pool.',
  keyword_target_path:
    'The target must be a storefront path starting with "/" (e.g. /urun/omega-3) without spaces.',
  keyword_locale: 'Language code must be two letters (e.g. tr).',
  keyword_required: 'Keyword cannot be empty.',
  pagespeed_not_configured:
    'No PageSpeed Insights key, or it failed its test. Integrations → PageSpeed Insights.',
  web_vitals_in_progress: 'A measurement is already running for this store. Try again when it finishes.',
  pagespeed_key_format: 'The API key format is wrong (Google Cloud → Credentials → API key).',
  pagespeed_key_invalid: 'Google did not accept this API key. It needs the PageSpeed Insights API.',
  pagespeed_quota: 'The PageSpeed Insights daily quota is used up. Try again tomorrow.',
  attribute_options_required: 'A choice attribute needs at least one option.',
  attribute_options_duplicate: 'The same option is listed twice.',
  attribute_name_taken: 'An attribute with this name already exists.',
  attribute_code_taken: 'An attribute with this code already exists.',
  attribute_type_locked:
    'The type of an attribute with product values cannot change. Create a new attribute or clear the values.',
  attribute_option_in_use: 'Option "{{option}}" is used by products; change those products first.',
  attribute_in_collection:
    'This attribute is used in the rule of collection "{{collection}}"; remove it from the rule first.',
  attribute_duplicate: 'The same attribute is entered twice.',
  attribute_value_invalid: 'The value does not fit this attribute type (number, option or yes/no).',
  collection_rules_required: 'A rule-based collection needs at least one condition.',
  collection_condition_invalid: 'Invalid condition: check the field, comparison and value.',
  synonym_terms_min: 'A group needs at least two different terms.',
  synonym_single_word: 'Each term must be a single word (no spaces or punctuation).',
  synonym_term_taken: '"{{term}}" is in another synonym group; a term can be in one group only.',
  synonym_limit: 'At most 500 synonym groups can be defined.',
  search_report_days: 'Period must be 7, 30 or 90 days.',
  pagespeed_unreachable: 'Could not reach PageSpeed Insights. Try again later.',
  server_event_id_required: 'First enter this provider’s ID (measurement ID / pixel) under Storefront tags.',
  server_event_secret_required: 'Enter the secret (API secret / access token) to turn on server events.',
  server_test_code_required: 'For a test, enter the test code from the provider’s "Test events" screen.',
  server_event_not_retryable: 'Only failed or skipped events can be retried.',
  server_secret_format: 'The secret must be at least 8 characters with no spaces.',
  server_test_code_format: 'The test code may contain only letters, digits, - and _.',
  merchant_not_linked:
    'No Merchant Center account is chosen for this store. Google connections → Store resources.',
  search_console_not_linked:
    'No Search Console property is chosen for this store. Google connections → Store resources.',
  inspection_quota_exceeded: "Today's URL inspection limit ({{limit}}) is used up. Try again tomorrow.",
  sitemap_not_in_property: "The store's domain is not covered by the chosen Search Console property.",
  url_not_in_property:
    "The address must be on this store's domain and in the chosen Search Console property.",
  date_range_invalid: 'The end date cannot be before the start date.',
  export_too_large: 'More than {{max}} rows in this period. Choose a shorter period.',
  unknown_role: 'Unknown role.',
  unknown: 'Unknown value.',
  unknown_brand: 'Unknown brand.',
  unknown_market: 'This market does not belong to this store.',
  mersis_format: 'The MERSIS number must be 16 digits.',
  hostname_format: 'Invalid domain name (e.g. zootopia.com.tr).',
  currency_locked: 'The currency of a list with prices cannot be changed.',
  currency_mismatch: 'The currencies do not match.',
  bulk_no_targets:
    'No products match the selection (for price actions: no priced products). Change the selection or filter.',
  bulk_not_in_preview: 'This bulk operation is not in preview.',
  bulk_preview_expired: 'The preview has expired (30 min). Preview again.',
  prices_changed_since_preview: 'Prices changed after the preview. Preview again.',
  bulk_not_applied: 'This bulk operation was not applied; it cannot be reverted.',
  ledger_entry_not_reversible:
    'This entry cannot be reversed. Order entries follow the order (cancel, refund, edit); a reversal cannot be reversed.',
  ledger_entry_already_reversed: 'This entry has already been reversed.',
  date_invalid: 'Enter a valid date.',
  report_period_too_long: 'The report period can be at most one year.',
  balance_payment_unavailable:
    'Card payment is not available right now. You can pay your balance by bank transfer or contact your sales representative.',
  balance_payment_nothing_due: 'There is no balance to pay.',
  balance_payment_item_closed:
    'One of the selected items is closed or has changed. Refresh the page and select again.',
  balance_payment_exceeds_balance: 'The amount cannot exceed the balance due (at most {{max}}).',
  balance_payment_too_small: 'The amount must be at least 1.00.',
  balance_payment_items_required: 'Select at least one item to pay.',
  bank_import_columns:
    'The bank statement has no date and amount (or credit) columns. Download the account transactions from your bank as CSV or Excel (XLSX); required columns: {{required}}.',
  bank_line_not_found: 'This line is not in the statement; preview again.',
  bank_line_blocked: 'This line cannot be posted (unreadable amount/date, future date or already posted).',
  bank_line_duplicate: 'This bank transaction was already posted to the ledger.',
  bank_dealer_not_found: 'The selected dealer was not found or is not approved.',
  ledger_import_columns: 'Required columns are missing: {{required}}. Use the template headers.',
  ledger_import_not_in_preview: 'This import is not in preview (applied or expired).',
  ledger_import_expired: 'The preview has expired (1 hour). Upload the file again.',
  ledger_import_empty: 'There are no valid rows to import.',
  credit_limit_exceeded: 'The order amount exceeds the open-account credit limit.',
  credit_overdue_block: 'New open-account orders are blocked because of overdue debt.',
  credit_limit_currency:
    'The credit limit is set in another currency; open account is unavailable in this currency.',
  quote_cart_locked: 'The cart holds an accepted quote; remove the quote from the cart to change it.',
  quote_closed: 'This quote is closed (ordered, declined or cancelled) and cannot be changed.',
  quote_not_acceptable: 'This quote is not open for acceptance or decline right now.',
  quote_expired: 'The quote has expired. Contact the store for a new quote.',
  quote_unavailable:
    'The quote in the cart is no longer valid (cancelled or closed). Remove it from the cart.',
  quote_changed: 'The quote was updated; open the quote page to see and accept the new version.',
  quote_lines_required: 'A quote needs at least one product.',
  dealer_not_approved: 'The dealer is not approved or has no dealer group.',
  quantity_below_minimum: 'Dealers can order at least {{min}} of this product.',
  quantity_not_multiple:
    'This product is sold in cases of {{step}}; the quantity must be a multiple of the case size.',
  min_order_not_met: 'The cart total is below the dealer minimum order amount.',
  reorder_nothing: 'Nothing in this order can be added to the cart.',
  company_viewer_cannot_order:
    'Your company account is view-only; you cannot place orders. The company owner or a buyer can order.',
  member_order_limit_exceeded:
    'The order total exceeds your threshold; an order of this amount needs the company owner’s approval. Send the cart for the owner’s approval or reduce it.',
  approval_not_needed:
    'This cart does not need company approval; only a buyer with an order limit sends carts for approval.',
  approval_already_granted: 'The cart is already approved; you can complete the order.',
  approval_closed: 'This approval request has already been decided.',
  approval_stale:
    'The cart changed after it was sent for approval, so this request cannot be approved. The buyer needs to send the current cart again.',
  rejection_reason_required: 'Enter a reason to decline (at least 3 characters).',
  po_number_required: 'Your company requires a purchase order (PO) number on orders.',
  po_document_required: 'Your company requires a purchase order (PO) document on orders; upload it.',
  po_number_format: 'The PO number contains characters that cannot be used.',
  dealer_scope_role_incompatible:
    'The "assigned dealers only" scope cannot be used with this role: the role opens data outside dealer scope (e.g. support tickets, marketing, audit log).',
  customer_email_taken: 'This email is registered to another customer account.',
  dealer_scope_restricted:
    'This action affects all dealers; your dealer scope is "assigned dealers only", so you cannot do it.',
  region_name_taken: 'A region with this name already exists.',
  commission_later_period_exists:
    'A later period already has statements; periods are calculated in order. Changes in this period appear as adjustments in the next period.',
  commission_statement_not_draft: 'The statement is not a draft; approved or paid statements cannot change.',
  commission_statement_not_approved: 'Approve the statement before marking it paid.',
  period_in_future: 'A period that has not started cannot be calculated.',
  sales_user_invalid: 'The selected user is not an active member of this business who can see dealers.',
  company_invite_mail_required:
    "Setup required: invitations can't be sent because the store's email service isn't set up.",
  company_invite_limit: "You've reached today's invitation limit ({{max}}); try again tomorrow.",
  company_invite_existing_account:
    'An account with this email address already exists in the store. To add this person to your company, contact the store.',
  company_member_self:
    "You can't change your own role or remove yourself from the company; contact the store for that.",
  company_member_already_active: 'This user has already activated their account.',
  company_link_limit: 'At most {{max}} links can be sent to this user per day; try again tomorrow.',
  company_last_owner: 'The company must keep at least one owner. Make another user owner first.',
  location_limit: 'A company can have at most {{max}} locations.',
  reminder_confirm_required:
    'Turning on payment reminders sends real emails to your dealers. Tick the confirmation box to turn them on.',
  must_be_after_start: 'The end must be after the start.',
  net_quantity_unit_pair: 'Enter net quantity and unit together.',
  payment_method_unavailable: 'This payment method is not available right now.',
  shipping_method_unavailable: 'The selected shipping method is not available for this cart.',
  cod_not_available_for_shipping: 'Cash on delivery is not available for the selected shipping method.',
  cod_limit_exceeded: 'The order total exceeds the cash on delivery limit.',
  legal_setup_required:
    'Orders cannot be taken until the pre-information form and distance sales contract are published.',
  legal_changed: 'The contract texts were updated. Please read and accept the new text.',
  payment_retry_not_allowed: 'Payment cannot be retried for this order.',
  use_payment_capture: 'An order becomes "paid" only through a payment record (use "Payment received").',
  payment_required_before_shipping: 'An unpaid order cannot be shipped.',
  bizimhesap_credentials_missing: 'BizimHesap firm ID (firmId) is missing.',
  bizimhesap_auth_failed: 'BizimHesap rejected the credentials. Check the firm ID/key.',
  bizimhesap_unreachable: 'BizimHesap could not be reached. Try again later.',
  bizimhesap_redirected:
    'BizimHesap redirected the request (HTTP {{status}} → {{location}}). The BizimHesap API address may have changed; the platform needs an update.',
  bizimhesap_unexpected_response:
    'BizimHesap returned an unexpected response (HTTP {{status}}, {{contentType}}); it is not JSON. The service may be under maintenance or the API address may have changed.',
  bizimhesap_timeout: 'BizimHesap did not respond within 20 seconds. Try again later.',
  bizimhesap_api_error: 'BizimHesap rejected the request: {{message}}',
  bizimhesap_shape_unknown:
    'The fields of the BizimHesap response were not recognised ({{endpoint}}). A masked sample is stored on the BizimHesap page; the field mapping needs an update.',
  invoice_provider_cancel_not_pending:
    'There is no pending BizimHesap cancellation for this invoice ({{state}}).',
  bizimhesap_customer_unmatched:
    'The dealer is not linked to a BizimHesap account ({{company}}). Link it under Integrations → BizimHesap → Import accounts; an invoice sent with an unknown code would create a new account in BizimHesap.',
  bizimhesap_cash_unmapped:
    'No BizimHesap cash account is selected for the payment method of this paid order. Choose one under Integrations → BizimHesap → Cash accounts.',
  bizimhesap_cash_unknown: 'This cash account is not in the BizimHesap list. Refresh the list first.',
  bizimhesap_write_confirm_required:
    'Turning on writes to BizimHesap creates records in your real accounting account. Tick the confirmation box to turn it on.',
  bizimhesap_customer_not_found: 'This account code is not in the BizimHesap account list.',
  bizimhesap_code_duplicate: 'The same account code cannot be given to two dealers.',
  bizimhesap_code_taken: 'This account code ({{code}}) is linked to another dealer.',
  bizimhesap_writes_disabled:
    'Writing to BizimHesap is off. The owner or an admin can turn it on under Integrations → BizimHesap → Writing to BizimHesap.',
  bizimhesap_collection_not_sendable: 'Only pending or failed collections can be sent.',
  bizimhesap_collection_not_uncertain: 'Only collections with an uncertain result can be resolved.',
  bizimhesap_correction_not_found: 'The selected invoice is not in the correction list.',
  invoice_not_allowed: 'An invoice cannot be created for this order (draft or cancelled).',
  invoice_exists: 'This order already has a valid invoice.',
  invoice_not_sendable: 'Only draft or failed invoices can be sent.',
  invoice_not_uncertain: 'The invoice is not in the "uncertain" state.',
  invoice_not_cancellable: 'This invoice cannot be cancelled.',
  legal_no_draft: 'There is no draft to publish.',
  legal_unknown_variable: 'The text contains a variable that is not defined for this document type.',
  legal_required_variables_missing: 'Required variables are missing from the text.',
  legal_placeholder_syntax: 'Invalid variable syntax: write {{field.name}}.',
  iyzico_credentials_missing: 'iyzico API key and secret key are missing.',
  iyzico_not_sandbox_key: 'The test environment needs an iyzico test key starting with "sandbox-".',
  iyzico_sandbox_key_in_live: 'A test (sandbox) key was entered for the live environment.',
  iyzico_auth_failed: 'iyzico rejected the keys.',
  iyzico_unreachable: 'iyzico could not be reached. Try again later.',
  paytr_credentials_missing: 'PayTR merchant ID, merchant key and salt are missing.',
  paytr_auth_failed: 'PayTR rejected the credentials.',
  paytr_unreachable: 'PayTR could not be reached. Try again later.',
  stripe_ok: 'Stripe connection verified (balance read).',
  stripe_credentials_missing: 'Stripe secret key and webhook signing secret are missing.',
  stripe_key_invalid:
    'The secret key must start with "sk_" (or restricted "rk_"), not the publishable "pk_" key.',
  stripe_not_test_key: 'The test environment needs a test key starting with "sk_test_".',
  stripe_test_key_in_live: 'A test key was entered for the live environment ("sk_live_" required).',
  stripe_webhook_secret_invalid:
    'The webhook signing secret must start with "whsec_" (Stripe → Webhooks → endpoint).',
  stripe_mode_mismatch: 'The key’s mode (test/live) does not match the selected environment.',
  stripe_auth_failed: 'Stripe did not accept the key.',
  stripe_unreachable: 'Stripe could not be reached. Try again later.',
  sipay_ok: 'Sipay connection verified (access token received).',
  sipay_credentials_missing: 'Sipay application ID, application secret and merchant key are missing.',
  sipay_auth_failed: 'Sipay credentials were not accepted.',
  sipay_unreachable: 'Sipay could not be reached. Try again later.',
  google_other_account_linked:
    'The account for this email is linked to another Google account. Sign in with that Google account or with your email and password.',
  google_signin_unavailable:
    'Sign-in with Google is not enabled in this store. Sign in with your email and password.',
  google_signin_state_invalid:
    'The Google sign-in request expired or was not started in this browser. Try "Continue with Google" again.',
  google_signin_denied: 'Sign-in with Google was cancelled.',
  google_signin_failed: 'Sign-in with Google could not be completed. Try again.',
  google_signin_client_invalid: "The store's Google sign-in client was rejected. Contact the store.",
  google_token_invalid: 'The Google identity could not be verified. Try again.',
  google_email_unverified:
    'Your Google account email is not verified. Register or sign in with your email and password.',
  google_dealer_not_allowed:
    'Dealer accounts cannot sign in with Google. Sign in with your email and password.',
  google_signin_account_disabled: 'This account is disabled. Contact the store.',
  google_signin_retry:
    'Another action was just made with this Google account. Try "Continue with Google" again.',
  google_signup_expired: 'The Google sign-up confirmation expired. Start again with "Continue with Google".',
  google_signin_owner_only: 'Only the business owner can enable sign-in with Google.',
  google_signin_not_configured:
    'First save and test the OAuth client under Integrations → Sign in with Google.',
  google_timeout: 'Google did not respond in time. Try again.',
  password_required_before_unlink:
    'Set a password for your account before removing the Google link; otherwise you could not sign in.',
  google_reauth_required:
    'For your security, sign in with Google again before setting a password; you can set it within 15 minutes of signing in.',
  privacy_password_required:
    'This action is confirmed with your password. Your account was created with Google, so first set a password under My account → Linked accounts.',
  dealer_application_password_required:
    'A dealer application cannot be made in a session signed in with Google. Sign in with your email and password (set a password under My account → Linked accounts if you have none).',
  geliver_credentials_missing: 'The Geliver API token is missing.',
  geliver_auth_failed:
    'Geliver rejected the API token. Check the token in the Geliver dashboard (API tokens).',
  geliver_timeout: 'Geliver did not respond within 30 seconds. Try again later.',
  geliver_unreachable: 'Geliver could not be reached. Try again later.',
  geliver_unavailable:
    'Geliver cannot respond right now (HTTP {{status}}). Try again in a few minutes; the label will not be bought twice.',
  geliver_rejected: 'Geliver rejected the request: {{reason}}',
  geliver_unexpected_response: 'Geliver returned an unexpected response; the operation was not completed.',
  geliver_not_connected:
    'Geliver is not connected. Enter the API token under Integrations → Shipping → Geliver and test the connection.',
  geliver_sender_required: 'No Geliver sender address is selected. Choose one under Shipping → Geliver.',
  geliver_sender_unknown: 'This sender address was not found in Geliver.',
  geliver_cod_unsupported:
    'Cash-on-delivery orders cannot be shipped with Geliver yet; ship them manually with a tracking number.',
  geliver_domestic_only: 'Geliver can only ship to addresses in Türkiye.',
  geliver_address_city_unknown:
    'The province in the delivery address was not recognised. Correct the order address.',
  geliver_address_district_required:
    'The delivery address has no district, or the district is not in that province. The carrier requires a district; correct the order address.',
  geliver_phone_required:
    "The delivery address has no valid phone number. The carrier requires the recipient's phone.",
  geliver_shipment_mismatch: 'This Geliver shipment does not belong to this order.',
  geliver_shipment_cancelled: 'This Geliver shipment was cancelled. Request offers again.',
  geliver_other_offer_accepted: 'Another offer has already been accepted for this shipment in Geliver.',
  geliver_offer_unknown: 'The selected offer is not part of this shipment. Refresh the offers.',
  geliver_not_a_geliver_shipment: 'This shipment was not created with Geliver.',
  geliver_cancel_after_pickup:
    'Once the carrier has picked up the parcel it cannot be cancelled here; contact Geliver or the carrier.',
  geliver_cancel_via_provider:
    'Cancel a shipment whose label was bought with Geliver using "Cancel in Geliver" (the label fee is refunded by Geliver).',
  geliver_dimension_invalid: 'Dimensions must be whole numbers between 1 and 300 cm.',
  paypal_ok: 'PayPal connection verified (webhook found).',
  paypal_credentials_missing: 'PayPal client ID, secret and webhook ID are missing.',
  paypal_auth_failed: 'PayPal did not accept the client ID or secret.',
  paypal_webhook_not_found: 'This webhook ID was not found in your PayPal app.',
  paypal_unreachable: 'PayPal could not be reached. Try again later.',
  reconcile_provider_error: 'The transaction report could not be fetched from the provider.',
  payment_token_mismatch: 'Payment details did not match.',
  card_payment_required: 'Card payments are confirmed only through provider verification.',
  already_paid: 'Payment for this order was already received.',
  refund_exceeds_payment: 'The refund exceeds the refundable amount.',
  no_captured_payment: 'This order has no captured payment.',
  refund_in_progress: 'A refund is already in progress for this payment.',
  // Reasons a payment needs action (shown on the payment row in the panel)
  amount_mismatch:
    'The amount reported by the provider does not match the order total. Check the provider panel.',
  amount_unverified:
    'The provider did not report the amount; the payment could not be verified. Check the provider panel.',
  test_mode_payment:
    'PayTR processed this transaction in test mode; no money was collected. Complete the "Live Mode" step in PayTR and cancel this order.',
  provider_review:
    "The payment is under the provider's fraud review. The result is checked hourly; the order stays open.",
  provider_review_stale:
    'The provider review did not finish within 7 days. Check the provider panel and settle the order manually.',
  provider_unreachable:
    'The payment result could not be verified because the provider was unreachable. Check the provider panel and settle the order manually.',
  payment_timeout: 'Payment time ran out; the order was cancelled.',
  bank_transfer_timeout: 'The bank transfer did not arrive in time; the order was cancelled.',
  redirect_from_invalid:
    'Invalid old address: it must be a path starting with "/" (the home page and system paths cannot be redirected).',
  redirect_host_invalid:
    'Invalid source domain: enter a domain such as "zootopiaglobal.com" or leave it empty for all domains.',
  redirect_to_invalid:
    'Invalid new address: it must be a path starting with "/" or a full address starting with https://.',
  redirect_loop: 'The new address is the same as the old one; the redirect would loop.',
  redirect_exists: 'A redirect already exists for this old address.',
  redirect_import_columns: 'The file has no "old address" and "new address" columns. Use the template.',
  redirect_status_invalid: 'The code must be 301 or 302.',
  redirect_duplicate_row: 'This old address appears more than once in the file.',
  redirect_import_has_errors: 'The file has {{count}} rows with errors; nothing was saved.',
  store_status_use_launch:
    'The publication status is not changed from the store form; use Store details → Publication status.',
  store_launch_incomplete:
    'Required items in the readiness list are missing; complete them before going live.',
  return_not_allowed: 'A return request cannot be created for this order (unpaid or cancelled order).',
  return_already_open: 'This order already has an open return request; wait for it to be resolved.',
  return_line_invalid: 'The selected item is not in this order.',
  return_quantity_exceeds: 'The return quantity cannot exceed the ordered quantity.',
  refund_not_pending: 'This refund has already been completed.',
  refund_still_running:
    'The refund may still be running. Wait {{minutes}} minutes after it started before resolving it manually.',
  store_live_requires_live_payments:
    'Card payments cannot be switched to the test environment while the store is live. Take the store offline first.',
  refund_note_required: 'Enter a note for a manual refund (e.g. refunded IBAN, date).',
  restock_only_after_shipping: 'Restocking is only possible for shipped orders.',
  card_provider_not_connected: 'The card provider connection test must succeed for this environment.',
  live_requires_sandbox_payment: 'At least one successful test payment is required before going live.',
  iban_taken: 'This IBAN is already registered.',
  staging_allowlist: 'Blocked on staging: the recipient is not on the e-mail allow list.',
  mail_allowlist_entry_invalid:
    'Invalid entry: enter a full e-mail address (name@example.com) or a domain (@example.com).',
  iban_invalid: 'Invalid IBAN (26 characters starting with TR and a valid check digit).',
  tiers_not_ascending: 'Weight tiers must be in ascending order.',
  shipment_closed: 'This shipment is closed (delivered/returned/cancelled).',
  https_url_required: 'The address must start with https://.',
  shipping_setup_required: 'Orders cannot be taken until a shipping method is set up.',
  setup_step_required: 'The go-live step cannot be skipped; it completes when the store is published.',
  // F7-19: düzenli sipariş
  subscriptions_disabled: 'Regular delivery is off in this store.',
  product_not_subscribable: 'This product is not sold for regular delivery.',
  subscription_interval_invalid: 'This frequency cannot be chosen; pick one of the listed intervals.',
  subscription_address_required: 'Add a delivery address in My account to deliver regularly.',
  subscription_limit: 'You can have at most 20 active regular deliveries; cancel one and try again.',
  subscription_out_of_stock:
    'There is not enough stock for this quantity; lower the quantity or try again later.',
  subscription_start_failed: 'Regular delivery could not be started; please try again shortly.',
  subscription_cancelled: 'This regular delivery has been cancelled.',
  subscription_not_active: 'This is only possible for an active regular delivery.',
  subscription_not_paused: 'Only a paused regular delivery can be resumed.',
  subscription_postpone_range: 'The new date can be from tomorrow up to 12 weeks ahead.',
  subscription_nothing_to_pay: 'There is no order awaiting payment.',
  customer_inactive: 'The customer account is not active.',
  pricing_failed: 'The order total could not be calculated; please try again shortly.',
};
